import { ReactNode } from "react";

import Box, { BoxProps } from "../../Box";
import styles from "./styles.module.css";

type ActionCardTextWrapperProps = {
  children: ReactNode;
} & BoxProps;

const ActionCardTextWrapper = ({ children, ...boxProps }: ActionCardTextWrapperProps) => (
  <Box direction="column" className={styles.textWrapper} {...boxProps}>
    {children}
  </Box>
);

ActionCardTextWrapper.displayName = "DS.ActionCard.TextWrapper";

export default ActionCardTextWrapper;
